import { lodash } from 'helpers';

import { FileTypeName } from '../../../../../api/types/entity';
import { LocalFileEntity } from '../../types';

export const parseAdditionalDocumentFileIdsParam = (
  files: LocalFileEntity[] | undefined
) =>
  lodash.compact(
    files
      ?.filter(
        (file) =>
          file.id &&
          file.uploadedByAdmin &&
          (!file.type ||
            file.type === FileTypeName.AdditionalDocument ||
            file.type === FileTypeName.Unknown)
      )
      .map((file) => file.id)
  );

export const parseDocumentsFileIdsParam = (
  files: LocalFileEntity[] | undefined
): Record<FileTypeName, LocalFileEntity[] | undefined> => {
  const filesMap = Object.entries(FileTypeName).reduce(
    (result, [key, value]) => {
      const filteredFiles = files?.filter((file) => file.type === value);
      return { ...result, [key]: filteredFiles };
    },
    {} as Record<FileTypeName, LocalFileEntity[] | undefined>
  );

  return filesMap;
};
